// extracted by mini-css-extract-plugin
export default {"page":"userorderlistpage_page__tmI8+","userOrderList":"userorderlistpage_userOrderList__6EoyO"};